import { render } from "./Navigation.vue?vue&type=template&id=01d37c70"
import script from "./Navigation.vue?vue&type=script&lang=ts"
export * from "./Navigation.vue?vue&type=script&lang=ts"

import "./Navigation.vue?vue&type=style&index=0&id=01d37c70&lang=css"
script.render = render

export default script